@defer (hydrate on immediate) {
	<div class="flex flex-col">
		<div class="relative">
			<div class="relative w-full z-[-999]">
				<img
					src="/assets/images/headers/desktop/header_dofus_desktop.png"
					class="w-full h-[850px] object-cover hidden md:block"
					alt="Header Dofus"
				/>
				<img
					src="/assets/images/headers/mobile/header_dofus_mobile.png"
					class="w-full h-[850px] object-cover block md:hidden"
					alt="Header Dofus"
				/>
			</div>
			<peps-separator></peps-separator>
		</div>
	</div>

	<div class="flex flex-col gap-20 mb-20">

		<div class="flex flex-row flex-wrap gap-8 mx-auto justify-center">
			@for(player of members$ | async; track player.id) {
				<peps-member-marvel-rivals-card
					[member]="player"
				></peps-member-marvel-rivals-card>
			}
		</div>

		<div class="flex flex-row flex-wrap gap-8 mx-auto justify-center">
			@for(player of coachesSubstitutes$ | async; track player.id) {
				<peps-member-marvel-rivals-card
					[member]="player"
					[isSubstitute]="true"
				></peps-member-marvel-rivals-card>
			}
		</div>

		<peps-achievement-row
			[achievements]="achievements"
		></peps-achievement-row>

		<div class="flex flex-col gap-10">

			<div class="flex flex-col md:flex-row justify-around items-center gap-4">
				<peps-title
					[subtitle]="'page.home.upcoming-matches.subtitle' | translate"
					[title]="'common.matches.lowercase' | translate"
				></peps-title>
				<span class="visible md:invisible"></span>
			</div>
			<peps-upcoming-matchs
				[matches]="matches"
			></peps-upcoming-matchs>
		</div>

	</div>
	<peps-last-videos></peps-last-videos>
}
